import React, { useState } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { User } from "@ecologi/shared";
import { DonationButton } from "./DonationButton";
import { ForestTitleEdit } from "./ForestTitleEdit";
import { Tooltip } from "../../Tooltip";
import { Typography } from "../../Typography";
import styles from "../styles/ForestTitleBox.module.scss";

const TitleWrapper = styled.div<{ isOwnProfile: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  z-index: 10;

  // to balance out the profile edit button
  ${(props) =>
    props.isOwnProfile &&
    css`
      padding-left: 24px;
    `}
`;

const Title = styled(Typography)`
  color: ${({ theme }) => theme.colors.snowdrop};
  word-wrap: break-word;
  max-width: 100%;
`;

export const ForestTitleBox = ({
  isDonateButtonVisible,
  isOwnProfile,
  onEditTitle,
  profile,
  setDonateModalState,
  setAlbertModalState,
  user,
}: {
  isDonateButtonVisible?: boolean;
  isOwnProfile: boolean;
  onEditTitle: (payload: any) => Promise<any>;
  profile: User;
  setDonateModalState: (state: boolean) => void;
  setAlbertModalState: (state: boolean) => void;
  user: User | null;
}) => {
  const [isEditMode, setEditModeState] = useState(false);

  const isBulkParent =
    profile.username === "wearealbert" ||
    profile.parentProfile?.username === "wearealbert";
  const forestDescriptor = "impact forest";

  let forestTitle = isOwnProfile
    ? `Your ${forestDescriptor}`
    : profile.niceNamePlural + ` ${forestDescriptor}`;

  if (profile.forestName) {
    forestTitle = profile.forestName;
  } else {
    if (profile.isFamilyPlan) {
      if (isOwnProfile) {
        forestTitle = `Your family's ${forestDescriptor}`;
      } else {
        forestTitle = profile.fullNamePlural + ` ${forestDescriptor}`;
      }
    } else if (profile.isBusinessPlan || !profile.subscription) {
      forestTitle =
        profile.groupName || profile.fullNamePlural + ` ${forestDescriptor}`;
    }
  }

  if (isEditMode) {
    return (
      <ForestTitleEdit
        onEditTitle={onEditTitle}
        setEditModeState={setEditModeState}
        profile={profile}
      />
    );
  }

  return (
    <div className={styles.wrapper} id="tour-forest">
      <TitleWrapper isOwnProfile={isOwnProfile}>
        <Title use="featureTitle" as="h1">
          {forestTitle}
        </Title>
        {isOwnProfile && (
          <Tooltip content={`Change ${forestDescriptor} name`}>
            <button
              className={styles.updateButton}
              data-testid="custom-forest-name-button"
              onClick={(e) => {
                e.preventDefault();
                setEditModeState(true);
              }}
            />
          </Tooltip>
        )}
      </TitleWrapper>
      {isDonateButtonVisible && (
        <DonationButton
          user={user}
          isBulkParent={isBulkParent}
          isOwnProfile={isOwnProfile}
          setDonateModalState={setDonateModalState}
          setAlbertModalState={setAlbertModalState}
        />
      )}
    </div>
  );
};
